const Host = "https://yy.yyxiaobin.com";
const ApiEdition = Host + "/api/v1/admin";
export default {
  //
  dashboard: ApiEdition + "/dashboard",
  //user
  //登录
  user_login: ApiEdition + "/user/login",

  // hao onsale
  //查询Yy号
  hao_onsale_query: ApiEdition + "/hao/onsale/query",

  // hao upload
  //查询Yy号
  hao_manage_upload: ApiEdition + "/file/uploadtest",
  //上传记录
  hao_upload_list: ApiEdition + "/hao/upload/list",

  // hao onsale
  //下架Yy号
  hao_down: ApiEdition + "/hao/onsale/down",
  //上架Yy号
  hao_upper: ApiEdition + "/hao/stock/upper",
  // 删除YY号
  hao_delete: ApiEdition + "/hao/stock/delete",
  // 删除YY号
  hao_modify: ApiEdition + "/hao/stock/modify",
  // 清空号码
  hao_empty: ApiEdition + "/hao/empty/more",

  // hao saled
  //查询Yy号
  hao_saled_query: ApiEdition + "/hao/saled/query",

  // hao stock
  //查询Yy号
  hao_stock_query: ApiEdition + "/hao/stock/query",

  // order
  // 查询交易中订单
  order_trading_query: ApiEdition + "/order/trading/query",
  // 交易中订单 发货
  order_trading_send: ApiEdition + "/order/trading/send",
  // 取消订单
  order_trading_cancel: ApiEdition + "/order/trading/cancel",

  // 查询已完成订单
  order_done_query: ApiEdition + "/order/done/query",
  // 查询已完成订单
  order_cancel_query: ApiEdition + "/order/cancel/query",

  //设置
  //店铺设置 查询
  setting_query: ApiEdition + "/setting/query",
  //店铺设置 设置
  setting_update: ApiEdition + "/setting/update",
  //个人设置 查询
  setting_user_query: ApiEdition + "/setting/user/query",
  //个人设置 查询
  setting_user_modify: ApiEdition + "/setting/user/modify",
  //个人设置 查询
  //设置
  //店铺设置 查询
  article_add: ApiEdition + "/article/add",
  //店铺设置 查询
  article_list: ApiEdition + "/article/list",
  //店铺设置 查询
  article_detail: ApiEdition + "/article/detail",
  //店铺设置 查询
  article_update: ApiEdition + "/article/update",
  //店铺设置 查询
  article_delete: ApiEdition + "/article/delete"
};
